import { makeStyles, Theme } from '@material-ui/core/styles';
import { spacingToPixel } from '@zeals/shared-utils';

export default makeStyles<Theme>((theme) => ({
  infoField: {
    marginTop: spacingToPixel(3, theme),
  },
}));
